<template>
    <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" layout='inline'>
        <a-form-item label="关键字" name='keyword'>
          <a-input v-model:value="search.keyword" :style="{width:'300px'}" placeholder="请输入红包说明、使用说明" />
        </a-form-item>
         <a-form-item label="创建日期">
          <a-range-picker v-model:value="time" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" @change="onChange" />
        </a-form-item>
        <a-form-item >
          <a-button type="primary" @click="initData({...search,page:1})">搜索</a-button>
        </a-form-item>
    </a-form>
    <a-table :pagination="pagination" rowKey="id" :loading="listLoading" bordered :columns="columns" :data-source="dataList" @change="pageSearchChange">
     <template v-slot:action="{ record }">
          <a-button type="primary" :ghost="!record.checked" @click="changeSelect(record)">{{record.checked?'已选择':'选择'}}</a-button>
     </template>
    </a-table>
</template>
<script>
import { iscode } from "@/utils/app";
import { getBonusList } from "@/api/red";
import { reactive, toRefs,ref, onMounted } from 'vue';
  import { message } from "ant-design-vue";
 let defSearch = {
    keyword: "",
    page: 1,
    limit: 8,
    key_type:'',
    start_time: '',
    end_time: '',
    bonus_status: 1,
    bonus_type: 1
  };
  const columns = [
      {
        title: "红包ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "红包金额",
        dataIndex: "amount",
        key: "amount",
      },
        {
        title: "红包说明",
        dataIndex: "description",
        key: "description",
      },
       {
        title: "使用说明",
        dataIndex: "use_description",
        key: "use_description",
        customRender:function({record}){
            return record.use_description || '-'
        }
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
      },
       {
        title: "操作",
        dataIndex: "action",
        key: "action",
         slots: { customRender: "action" },
      }
  ]
export default{
  props:{
     id:{
       type:Number,
       default:null
     }
  },
    setup(props,{emit}){
        const search = ref({ ...defSearch })
       const state = reactive({
           time:[],
           listLoading:false,
           pagination:{ //分页
             total:0,
             current:1,
             pageSize:8,
           },
           dataList:[]
       })

       const methods ={
           pageSearchChange(e){
              search.value.page = e.current;
              methods.initData(search.value)
           },
            onChange(e){
              search.value.start_time = e[0];
              search.value.end_time = e[1];
            },
           async initData(values){
                state.listLoading = true;
                state.dataList = [];
                try {
                  let res = await getBonusList(values).then((res) => res.data);
                  state.listLoading = false;
                  if (iscode(res)) {
                    state.dataList = res.data.data || [];
                    state.pagination.total = res.data.total;
                     state.pagination.current = res.data.current_page;
                     state.dataList.forEach((v)=>{
                        v.checked = false;
                         if(v.id==props.id){
                           console.log(v,'2')
                            v.checked = true;
                         }
                     })
                  } else {
                    message.error(res.msg);
                  }
                } catch (e) {
                  state.listLoading = false;
                }
          },
          changeSelect(record){
             record.checked = true;
             emit('change',record);
          }
       }

       onMounted(()=>{
           methods.initData(search.value)
       })

       return {
           ...toRefs(state),
           search,
           ...methods,
           columns
       }
    }
}
</script>
